import { render, staticRenderFns } from "./PsiCardHeading.vue?vue&type=template&id=547c6f53&"
import script from "./PsiCardHeading.vue?vue&type=script&lang=js&"
export * from "./PsiCardHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardTitle,VChip,VIcon,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('547c6f53')) {
      api.createRecord('547c6f53', component.options)
    } else {
      api.reload('547c6f53', component.options)
    }
    module.hot.accept("./PsiCardHeading.vue?vue&type=template&id=547c6f53&", function () {
      api.rerender('547c6f53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/src/components/cards/PsiCardHeading.vue"
export default component.exports